export default __webpack_public_path__ + "static/media/environmentalAI.2443c938.png";